import { Link } from "react-router-dom";
import { works } from "@/mocks/works";
import SectionHeading from "@/components/feature/SectionHeading";

const rankColors = ["bg-primary-500", "bg-secondary-500", "bg-accent-500"];

export default function RankingSection() {
  const top = [...works].sort((a, b) => b.rating - a.rating).slice(0, 8);

  return (
    <section className="bg-background-50 py-12 md:py-16" aria-label="热门榜单">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="热门榜单"
          title="本周热漫排行榜"
          desc="根据读者热度与评分实时生成的榜单，帮你快速锁定大家都在追的好作品。"
        />
        <div className="overflow-hidden rounded-xl border border-background-200 bg-background-50">
          <ul className="divide-y divide-background-100">
            {top.map((work, idx) => (
              <li key={work.id}>
                <Link
                  to={`/work/${work.id}`}
                  className="group flex items-center gap-3 px-4 py-3 transition-colors hover:bg-background-100 md:gap-5 md:px-6"
                >
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg font-heading text-base font-bold text-background-50 md:h-9 md:w-9 ${
                      rankColors[idx] ?? "bg-background-300 text-foreground-800"
                    }`}
                  >
                    {idx + 1}
                  </span>
                  <div className="hidden sm:block">
                    <img
                      src={work.cover}
                      alt={`${work.title} 榜单封面`}
                      title={`${work.title} 热门榜单`}
                      className="h-14 w-10 rounded-md object-cover"
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <h3 className="truncate font-heading text-sm font-bold text-foreground-900 md:text-base">
                        {work.title}
                      </h3>
                      {work.isExclusive && (
                        <span className="hidden shrink-0 rounded-full bg-primary-100 px-2 py-0.5 text-[10px] font-bold text-primary-700 md:inline">
                          独家
                        </span>
                      )}
                    </div>
                    <p className="mt-0.5 truncate text-xs text-foreground-500">
                      {work.author} · {work.latestChapter}
                    </p>
                  </div>
                  <div className="flex shrink-0 items-center gap-1 text-sm text-secondary-600">
                    <i className="ri-star-fill" />
                    <b className="text-foreground-800">{work.rating}</b>
                  </div>
                  <span className="hidden w-16 shrink-0 text-right text-xs text-foreground-500 md:block">
                    {work.views}人气
                  </span>
                  <i className="ri-arrow-right-s-line text-lg text-foreground-400 group-hover:text-primary-500" />
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}